import React, { Component } from 'react';

import AllDay from './AllDay.js';
import moment from 'moment';


class AllDayContainer extends Component {
    constructor(props){
        super(props);
        this.state = {timeRemaining:0};
        this.tickDuration = 100;
        this.timerId = null;
        this.timerEndsAt = null;
        this.onComplete = this.onComplete.bind(this);
        this.tick = this.tick.bind(this);
    }
    componentWillMount() {
        this.start();
    }
    componentWillUnmount() {
        this.stop();
    }
    start() {
        if(this.timerId===null) {
            var endsAt = new Date();
            endsAt.setHours(24,0,0,0);
            this.timerEndsAt= endsAt.getTime();
            this.timerId = setInterval(this.tick, this.tickDuration);
        }
    }
    stop() {
        if(this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }
    tick() {
        var now = new Date().getTime();
        var timeRemaining = this.timerEndsAt - now;
        this.setState({timeRemaining:timeRemaining});
    }
    onComplete() {
        this.props.onComplete({action:{increment:1}});
    }
    render() {
        var challenge = this.props.challenge;
        return <AllDay challenge={challenge}
                       timeRemaining={this.state.timeRemaining}
                       onComplete={this.onComplete}
                       completePending={this.props.completePending}
                       userChallenge={this.props.userChallenge || challenge.userChallenge}
                       withMax={this.props.withMax} />;
    }

}

export default AllDayContainer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/AllDayContainer.js